import { ICheckInOutOverride } from "@vmosolutions/oc-interfaces";
import { BaseTimelineGL } from "src/SharedGL/BaseTimelineGL";
import { Camera } from "src/SharedGL/Camera";
import { CrewScheduleErrorsGL } from "./CrewScheduleErrorsGL";
import { ICrewGL } from "./CrewScheduleGL";
import { PairingsGL } from "./PairingsGL";

const stopShowingCheckInOutsAfterDaysZoomed = 10;
const lineWidth = 1;
const horizontalLineWidth = 5;
const lineColour = "yellow";

export function drawCheckInOutIndicators(
  canvasCtx: CanvasRenderingContext2D,
  camera: Camera,
  crewGL: ICrewGL,
  checkInOverrides: ICheckInOutOverride[],
  biddingModeHeight = 0 // If not passed in, assume 0, when in bidding mode this returns the addition height from nfa count bars.
): void {
  if (camera.currentZoom < stopShowingCheckInOutsAfterDaysZoomed * 24 * 60 * 60 * 1000) {
    const y = crewGL.rowStart + PairingsGL.pairingYStart / 2;
    const [yMin] = camera.getYRange();
    const y0: number = y + BaseTimelineGL.timelineStart + biddingModeHeight;
    const delta: number = y0 - yMin;
    const yStart = (delta + CrewScheduleErrorsGL.yHeight) * window.devicePixelRatio;

    if (BaseTimelineGL.timelineStart > yStart) {
      //don't draw check in ontop of day axis
      return;
    }
    checkInOverrides.forEach((LMs: ICheckInOutOverride) => {
      const startPixel = camera.timeAxisToPixelCoords(LMs.time, canvasCtx.canvas.width);
      canvasCtx.save();
      canvasCtx.lineWidth = lineWidth;
      canvasCtx.strokeStyle = lineColour;
      canvasCtx.beginPath();
      canvasCtx.setLineDash([2, 1]);
      canvasCtx.moveTo(startPixel, yStart);
      canvasCtx.lineTo(startPixel, yStart + PairingsGL.pairingHeight * window.devicePixelRatio);
      canvasCtx.stroke();
      canvasCtx.beginPath();
      canvasCtx.setLineDash([]);
      canvasCtx.moveTo(startPixel, yStart + PairingsGL.pairingHeight / 2);
      canvasCtx.lineTo(startPixel + horizontalLineWidth * (LMs.inout ? 1 : -1), yStart + PairingsGL.pairingHeight / 2);
      canvasCtx.stroke();
      canvasCtx.restore();
      // debugger;
    });
  }
}
